<header class="d-flex flex-wrap justify-content-center mb-4 border-bottom header-bg fixed-top ">
  <a routerLink="/home" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none my-auto ms-3">
    <img class="navbar-brand" src="../../../assets/images/logo.svg">
  </a>
  <div class="nav nav-pills my-auto mx-3">
    <h1 class="my-0"> {{headerText}}</h1>
  </div>
</header>

  